import React, {
  MouseEventHandler,
  useCallback,
  useEffect,
  useRef,
  useState,
} from 'react';
import styled from 'styled-components';
// @ts-expect-error ts-migrate(2305) FIXME: Module '"styled-system"' has no exported member 'P... Remove this comment to see the full error message
import { Props as StyleProps } from 'styled-system';

import Box from 'components/Box';
import { Button } from 'components/Button';
import Flex from 'components/Flex';
import Icon from 'components/Icon/Icon';
import ClientOnly from 'containers/ClientOnly';
import { colors, transition } from 'theme';
import { getJson } from 'utils//http';

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const SERVICES: Record<string, any> = {
  youtube: {
    urlPattern: /youtube|youtu\.be/,
    idPattern: /(youtu\.be\/|\.com\/v\/|.com\/watch\?v=)([\w-]+)/,
    getSrc: ({ autoplay, videoId }) =>
      `https://www.youtube.com/embed/${videoId}?enablejsapi=1&autoplay=${autoplay}&origin=${
        typeof window !== 'undefined' ? window.location.origin : ''
      }`,
    getImage: ({ videoId }) =>
      `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`,
    scriptSrc: '//www.youtube.com/iframe_api',
  },
  vimeo: {
    urlPattern: /vimeo/,
    idPattern: /(vimeo\.com\/video\/|vimeo\.com\/)([0-9]+)/,
    getSrc: ({ videoId }) =>
      `https://player.vimeo.com/video/${videoId}?api=1&muted=1`,
    getImage: ({ videoImageId }) =>
      `https://i.vimeocdn.com/video/${videoImageId}.webp?mw=1200&mh=675&q=70`,
    scriptSrc: '//player.vimeo.com/api/player.js',
  },
};

const getIframeId = ({
  prefix,
  videoId,
}: {
  prefix: string;
  videoId: string;
}) => `${prefix}-video-${videoId}`;

const getImage = ({
  videoId,
  videoType,
}: {
  videoId: string;
  videoType: string;
}) => {
  const protocol =
    typeof window !== 'undefined' ? window.location.protocol : 'https:';
  return SERVICES[videoType].getImage({
    videoId,
    protocol,
  });
};

const Iframe = styled.iframe`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 0;
`;
export const PlayButton = styled(
  ({
    onClick,
    className,
    asButton,
    smallButton,
    disabled,
  }: {
    onClick?: MouseEventHandler;
    className?: string;
    asButton?: boolean;
    smallButton?: boolean;
    disabled?: boolean;
  }) => {
    const Component = asButton ? Button : 'div';
    return (
      <Component
        className={className}
        onClick={onClick}
        // @ts-expect-error ts-migrate(2322) FIXME: Type '{ children: Element; className: string; smal... Remove this comment to see the full error message
        smallButton={smallButton}
        disabled={disabled}
      >
        <Icon name="play-button" />
      </Component>
    );
  }
)`
  svg {
    width: ${({ smallButton }) => (smallButton ? 60 : 120)}px;
    height: ${({ smallButton }) => (smallButton ? 60 : 130)}px;
    * {
      transition: all ${transition};
    }
  }
  &:hover {
    svg {
      width: ${({ smallButton }) => (smallButton ? 65 : 138)}px;
    }
    circle {
      fill: white;
      filter: drop-shadow(0 4px 4px rgba(0, 0, 0, 0.25));
    }
    path,
    polyline {
      fill: ${colors.waterBlue};
    }
  }
`;
const ClickOverlay = styled(
  ({
    className,
    onClick,
    isReady,
    noPlayer,
    smallButton,
    showOverlay,
    hideButton,
  }: {
    className?: string;
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    onClick: (...args: Array<any>) => any;
    isReady: boolean;
    noPlayer?: boolean;
    smallButton?: boolean;
    showOverlay?: boolean;
    hideButton?: boolean;
    disabled?: boolean;
  }) => (
    <Flex
      alignItems="center"
      justifyContent="center"
      width="100%"
      height="100%"
      position="absolute"
      top="0"
      left="0"
      className={className}
    >
      {!hideButton && (
        <PlayButton
          onClick={onClick}
          asButton={!noPlayer}
          disabled={showOverlay ? false : !isReady}
          smallButton={smallButton}
        />
      )}
    </Flex>
  )
)<{ image: string; isReady?: boolean }>`
  background-image: url('${(props) => props.image}');
  background-size: cover;
  background-position: center;
  transition: all ${transition};
  ${(props) =>
    !props.isReady
      ? `background-color: rgba(0,0,0,0.3); button { opacity: 0.3; }`
      : ``}
  ${(props) =>
    props.showOverlay
      ? `
      border-radius: 11px;
      border: 1px solid ${colors.aluminum};
      box-shadow: 0px 4px 9px 0px rgba(0, 0, 0, 0.1);

      button:before {
        content: "";
        position: absolute;
        height: 100%;
        left: 0;
        top: 0;
        width: 100%;
      }
    `
      : ``}
  ${(props) =>
    !props.image || props.image.length === 0
      ? `
    background-color: ${colors.silver}
  `
      : ``}
`;
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line react/function-component-definition
export const AmpVideo = ({ url }: { url: string }) => {
  const videoType =
    Object.keys(SERVICES).find((type) => SERVICES[type].urlPattern.test(url)) ||
    'youtube';
  const VideoComponent = `amp-${videoType}`;

  const videoId = (() => {
    if (videoType && videoType.length > 0) {
      const match = url.match(SERVICES[videoType].idPattern);
      return match && match[2] ? match[2] : '';
    }

    return '';
  })();

  return (
    <VideoComponent
      data-videoid={videoId}
      // @ts-expect-error ts-migrate(2322) FIXME: Type '{ "data-videoid": string; layout: string; wi... Remove this comment to see the full error message
      layout="responsive"
      width="480"
      height="270"
    />
  );
};
type Props = StyleProps & {
  allowFullScreen?: boolean;
  url: string;
  fill?: boolean;
  disabled?: boolean;
  prefix?: string;
  noPlayer?: boolean;
  smallButton?: boolean;
  showOverlay?: boolean;
  hideButton?: boolean;
  thumbnail?: string;
  videoShouldStop?: boolean;
  ytRecommendFromChannel?: boolean;
};

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line react/function-component-definition
const Video = ({
  allowFullScreen = true,
  url,
  fill,
  disabled,
  prefix = '',
  noPlayer,
  smallButton,
  showOverlay,
  hideButton,
  thumbnail,
  videoShouldStop,
  ytRecommendFromChannel,
  ...props
}: Props) => {
  const [image, setImage] = useState('');
  const [playVideo, setPlayVideo] = useState(null);
  const [player, setPlayer] = useState(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const [isReady, setIsReady] = useState(!!showOverlay);
  const iframeEl = useRef(null);
  const videoType =
    Object.keys(SERVICES).find((type) => SERVICES[type].urlPattern.test(url)) ||
    '';

  const videoId = (() => {
    if (videoType && videoType.length > 0) {
      const match = url.match(SERVICES[videoType].idPattern);
      return match && match[2] ? match[2] : '';
    }

    return '';
  })();

  const protocol =
    typeof window !== 'undefined' ? window.location.protocol : 'https:';
  const src = SERVICES[videoType]
    ? SERVICES[videoType].getSrc({
        videoId,
        protocol,
        autoplay: isPlaying && showOverlay,
      })
    : '';
  const setupPlayer = useCallback(() => {
    if (!isReady) {
      setIsReady(true);
    } else if (
      !playVideo &&
      !noPlayer &&
      videoType === 'vimeo' &&
      iframeEl &&
      iframeEl.current &&
      typeof window !== 'undefined' &&
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'Vimeo' does not exist on type 'Window & ... Remove this comment to see the full error message
      window.Vimeo
    ) {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'Vimeo' does not exist on type 'Window & ... Remove this comment to see the full error message
      const vimeoPlayer = new window.Vimeo.Player(
        getIframeId({
          prefix,
          videoId,
        })
      );
      setPlayVideo(() => () => {
        setIsPlaying(true);
        vimeoPlayer.play();
      });
      setPlayer(vimeoPlayer);
    }
  }, [isReady, noPlayer, playVideo, prefix, videoId, videoType]);
  useEffect(() => {
    if (videoShouldStop && player) {
      player.stopVideo();
    }
  }, [player, videoShouldStop]);
  useEffect(() => {
    const createScript = ({
      onLoad,
      onYouTubeIframeAPIReady,
    }: {
      // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      onLoad?: (...args: Array<any>) => any;
      // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      onYouTubeIframeAPIReady?: (...args: Array<any>) => any;
    } = {}) => {
      const script = document.createElement('script');
      if (onLoad) script.onload = onLoad;
      if (onYouTubeIframeAPIReady)
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'onYouTubeIframeAPIReady' does not exist ... Remove this comment to see the full error message
        window.onYouTubeIframeAPIReady = () => onYouTubeIframeAPIReady();
      script.src = SERVICES[videoType].scriptSrc;
      const firstScriptTag = document.getElementsByTagName('script')[0];

      if (firstScriptTag && firstScriptTag.parentNode) {
        firstScriptTag.parentNode.insertBefore(script, firstScriptTag);
      }
    };

    if (videoType && videoType.length > 0) {
      let newImage;

      if (thumbnail) {
        newImage = thumbnail;
      } else if (videoType === 'vimeo') {
        getJson(`//vimeo.com/api/oembed.json?url=${src}`).then((res) => {
          // @ts-expect-error ts-migrate(2339) FIXME: Property 'thumbnail_url' does not exist on type 'u... Remove this comment to see the full error message
          const videoImageId = res.thumbnail_url.match(
            /vimeocdn\.com\/video\/([0-9]+)_/
          )[1];
          setImage(
            SERVICES.vimeo.getImage({
              videoImageId,
            })
          );
        });
        newImage = '';
      } else {
        newImage = getImage({
          videoType,
          videoId,
        });
      }

      if (!image) {
        setImage(newImage);
      }

      if (SERVICES[videoType] && SERVICES[videoType].scriptSrc) {
        if (videoType === 'youtube' && !playVideo) {
          setPlayVideo(() => () => {
            setIsPlaying(true);

            // @ts-expect-error ts-migrate(2339) FIXME: Property 'YT' does not exist on type 'Window & typ... Remove this comment to see the full error message
            if (window.YT && window.YT.loaded) {
              setPlayer(
                // @ts-expect-error ts-migrate(2339) FIXME: Property 'YT' does not exist on type 'Window & typ... Remove this comment to see the full error message
                new window.YT.Player(
                  getIframeId({
                    prefix,
                    videoId,
                  }),
                  {
                    height: '100%',
                    width: '100%',
                    videoId,
                    playerVars: {
                      autoplay: 1,
                      modestbranding: 1,
                      rel: ytRecommendFromChannel ? 0 : undefined,
                    },
                  }
                )
              );
            } else {
              createScript({
                onYouTubeIframeAPIReady: () => {
                  setIsReady(true);
                  setPlayer(
                    // @ts-expect-error ts-migrate(2339) FIXME: Property 'YT' does not exist on type 'Window & typ... Remove this comment to see the full error message
                    new window.YT.Player(
                      getIframeId({
                        prefix,
                        videoId,
                      }),
                      {
                        height: '100%',
                        width: '100%',
                        videoId,
                        playerVars: {
                          autoplay: 1,
                          modestbranding: 1,
                          rel: ytRecommendFromChannel ? 0 : undefined,
                        },
                      }
                    )
                  );
                },
              });
            }
          });
        } else if (videoType === 'vimeo') {
          // @ts-expect-error ts-migrate(2339) FIXME: Property 'Vimeo' does not exist on type 'Window & ... Remove this comment to see the full error message
          if (window && typeof window.Vimeo === 'undefined') {
            createScript({
              onLoad: () => setupPlayer(),
              // @ts-expect-error ts-migrate(2345) FIXME: Argument of type '{ onLoad: () => void; videoType:... Remove this comment to see the full error message
              videoType,
            });
          } else {
            setupPlayer();
          }
        }
      } else {
        setIsReady(true);
        setIsPlaying(true);
      }
    }
  }, [
    isPlaying,
    isReady,
    prefix,
    setupPlayer,
    image,
    setImage,
    src,
    thumbnail,
    videoId,
    videoType,
    playVideo,
    player,
    ytRecommendFromChannel,
  ]);
  return (
    <Box
      position="relative"
      pb={fill ? '0' : '56.25%'}
      height={fill ? '100%' : 'auto'}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
    >
      <ClientOnly>
        {!noPlayer && !showOverlay ? (
          <Iframe
            allow={allowFullScreen ? 'fullscreen;' : undefined}
            data-qa-id={`${prefix}-video`}
            src={src}
            frameBorder="0"
            id={getIframeId({
              prefix,
              videoId,
            })}
            ref={iframeEl}
            title="Video"
          />
        ) : null}
        {showOverlay ? (
          <div
            id={getIframeId({
              prefix,
              videoId,
            })}
          />
        ) : null}
        {!isPlaying && (videoType !== 'youtube' || noPlayer || showOverlay) && (
          <ClickOverlay
            image={image}
            onClick={disabled ? () => undefined : playVideo}
            isReady={isReady}
            disabled={disabled || noPlayer}
            smallButton={smallButton}
            showOverlay={showOverlay}
            hideButton={hideButton}
            noPlayer={noPlayer}
          />
        )}
      </ClientOnly>
    </Box>
  );
};

// eslint-disable-next-line import/no-default-export
export default Video;
